import React from "react";
import { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import { TFunction } from "i18next";

/** Колонки таблицы каталогов, по которым возможна клиентская сортировка */
export const CATALOGS_SORTABLE_COLUMNS = ["name", "createdAt", "createdBy"];

const localeCompare = (a: unknown, b: unknown) =>
  String(a ?? "").localeCompare(String(b ?? ""));

const COMPARATORS: Record<string, (a: any, b: any) => number> = {
  name: (a, b) => localeCompare(a.name, b.name),
  createdAt: (a, b) => (a.createdAtRaw ?? 0) - (b.createdAtRaw ?? 0),
  createdBy: (a, b) => localeCompare(a.createdBy, b.createdBy),
};

export const getCatalogsColumns = (
  t: TFunction,
  options: string[],
  sortField?: string,
  sortType?: string
): ColumnsType<any> =>
  options.map((option) => {
    const comparator = COMPARATORS[option];
    const sortOrder: SortOrder | undefined =
      comparator &&
      sortField === option &&
      (sortType === "ASC" || sortType === "DESC")
        ? sortType === "DESC"
          ? "descend"
          : "ascend"
        : undefined;

    return {
      title: t(`documentLib.table.${option}`),
      dataIndex: option,
      key: option,
      ...(comparator ? { sorter: comparator, sortOrder } : {}),
      render: (value: any) => <span>{value}</span>,
    };
  });
